import {getCurrentYear} from '../../utils/commons'
import ValueFirstChoicesLogo from './logo'
import valueFirstChoicesStyles from './styles'

const baseConfig = {
  domainName: 'valuefirstchoices' as const,
  domainType: 'picks' as const,
  siteName: 'Value First Choices',
  favicon: '/favicons/valuefirstchoices.png',
  logo: <ValueFirstChoicesLogo className="size-9 shrink-0 tablet:size-6" />,
  styles: valueFirstChoicesStyles,
}

const localeConfigs = {
  us: {
    measurementId: 'G-XMGZ3T6HDF',
    camelCaseUrl: 'ValueFirstChoices.com',
    title: (category: string, count: string) =>
      `Best ${count} ${category} to Buy in ${getCurrentYear()} | ValueFirstChoices.com – Smart Picks & Best Value Deals`,
    description: (category?: string, count?: string) =>
      `Discover the best ${count} ${category} for ${getCurrentYear()} at ValueFirstChoices.com. Data-driven reviews, detailed comparisons, and practical tips to help you get the most value for your money.`,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
